"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Link = _interopRequireDefault(require("../../../atoms/Link"));

var _default = function _default(_ref) {
  var title = _ref.title,
      options = _ref.options,
      linksAs = _ref.linksAs;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
    item: true,
    text: title
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown.Menu, null, options.map(function (_ref2, index) {
    var linkTitle = _ref2.title,
        as = _ref2.as,
        pageType = _ref2.pageType,
        slug = _ref2.slug,
        url = _ref2.url,
        rest = (0, _objectWithoutProperties2["default"])(_ref2, ["title", "as", "pageType", "slug", "url"]);
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown.Item, {
      key: linkTitle
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], (0, _extends2["default"])({
      to: pageType === 'External' ? url : slug,
      linkAs: as || linksAs,
      title: linkTitle,
      internal: pageType !== 'External'
    }, rest)));
  })));
};

exports["default"] = _default;